import { FieldHtmlNameUtil, Trans } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import AbstractSubmitSignupScreen from './AbstractSubmitSignupScreen';
import UnifiedSignupGradeLevel from '../session-info/UnifiedSignupGradeLevel';

export default class EduDetailsStudentK12SignupScreen extends AbstractSubmitSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-details-edu-student-k12';

  public getThisScreensVisibleComponents(): UnifiedSignupScreenComponent[] {
    this.getField(FieldHtmlNameUtil.whatAreYouUsingOnshapeFor).name = Trans.byKey('whatAreYouUsingOnshapeFor');
    this.getField(FieldHtmlNameUtil.acceptedIs13YearsOldOrOlder).name = Trans.byKey('acceptedIs13YearsOldOrOlder');
    this.getField(FieldHtmlNameUtil.acceptedIsClassroom).name = Trans.byKey('acceptedIsClassroom');
    this.getField(FieldHtmlNameUtil.privacyConsentAccepted).name = Trans.byKey('privacyConsentAccepted');
    this.getField(FieldHtmlNameUtil.websiteurl).name = Trans.byValue('School website URL');
    this.getField(FieldHtmlNameUtil.schoolName).componentName = 'text-input-field';

    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.schoolName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.websiteurl),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.studentGraduationYear),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.whatAreYouUsingOnshapeFor),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.acceptedIs13YearsOldOrOlder),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.acceptedIsClassroom),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.privacyConsentAcceptedStudent),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.recaptcha),
      }),
    ];
  }

  public predicate(): boolean {
    const {
      gradeLevel, chosenPlan, completedDetailsScreens, formSubmitStatus,
    } = this.sessionInfo.value;
    if (formSubmitStatus !== null && formSubmitStatus !== 'submit-failed') {
      return false;
    }
    if (gradeLevel === null || chosenPlan === null || !chosenPlan.compareTo(UnifiedSignupPlan.edu)) {
      return false;
    }
    if (completedDetailsScreens.length !== 0) {
      return false;
    }

    if (!gradeLevel.compareTo(UnifiedSignupGradeLevel.gradeSchool)) {
      return false;
    }

    return true;
  }
}
